export default __webpack_public_path__ + "static/media/fontello.90529640.eot";